import { checkIsCallTask, checkReservationExists, checkWorker, getReservationsByTask } from "../../ActionUtils";
import { Task } from "~/packages/taskrouter";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { sendWorkerTrackingEvent } from "~/modules/telemetry/utils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";
import { createFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";































export class CancelVoiceTaskTransfer implements Action<Promise<Task>> {
    


    readonly #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        logger.debug(`CancelVoiceTaskTransfer invoked with taskSid: ${this.#taskSid}`);

        const checkCommons = {
            actionName: "CancelVoiceTaskTransfer",
            moduleName: "actions/Voice",
            analytics,
            context,
            worker,
            logger
        };

        checkWorker(worker, {
            ...checkCommons,
            event: EVENTS.CancelVoiceTaskTransfer,
            extra: {
                taskSid: this.#taskSid
            }
        });

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "accepted");

        checkReservationExists(reservation, this.#taskSid, {
            ...checkCommons,
            event: EVENTS.CancelVoiceTaskTransfer,
            extra: {
                taskSid: this.#taskSid
            }
        });

        const validReservation = reservation!;

        checkIsCallTask(validReservation.task, {
            ...checkCommons,
            event: EVENTS.CancelVoiceTaskTransfer,
            extra: {
                taskSid: this.#taskSid,
                reservationSid: validReservation.sid
            }
        });

        if (!validReservation.task?.transfers?.outgoing) {
            const errorMsg = `CancelVoiceTaskTransfer: No active transfer for task ${this.#taskSid}`;
            logger.error(errorMsg);
            sendWorkerTrackingEvent(EVENTS.CancelVoiceTaskTransfer, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: validReservation.sid
            });
            return Promise.reject(
                createFlexSdkError(context)(
                    ErrorCode.NoActiveTransferForVoiceTask,
                    { severity: ErrorSeverity.Error },
                    errorMsg
                )
            );
        }
        try {
            const outgoingTransfer = validReservation.task.transfers.outgoing;
            await outgoingTransfer.cancel();

            sendWorkerTrackingEvent(EVENTS.CancelVoiceTaskTransfer, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSid: validReservation.sid,
                outgoingTransferSid: outgoingTransfer.sid
            });

            return validReservation.task;
        } catch (error) {
            const errorMsg = `CancelVoiceTaskTransfer: Failed to cancel voice transfer for task ${this.#taskSid}`;
            sendWorkerTrackingEvent(EVENTS.CancelVoiceTaskTransfer, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: validReservation.sid
            });
            return Promise.reject(
                createFlexSdkError(context)(
                    ErrorCode.FailedToCancelVoiceTaskTransfer,
                    { severity: ErrorSeverity.Error },
                    errorMsg,
                    error
                )
            );
        }
    }
}
